import { c as _c } from "react/compiler-runtime";
/**
 * Marks the current route as a full-screen / immersive experience so the global
 * Header and Footer are hidden via CSS (see src/styles/tailwind.css).
 *
 * This is rendered server-side from each immersive page, so the signal is in the
 * prerendered HTML and the chrome is hidden from the very first paint. The old
 * approach gated Header/Footer on `usePathname()`, which resolves to null during
 * Vercel's prerender — so the chrome briefly rendered server-side and was then
 * stripped on hydration (a flash + hydration mismatch).
 */
export function HideSiteChrome() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span data-hide-site-chrome={true} hidden={true} aria-hidden="true" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}